import { render, staticRenderFns } from "./CustomReport.vue?vue&type=template&id=b1a6980c&scoped=true"
import script from "./CustomReport.vue?vue&type=script&lang=js"
export * from "./CustomReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a6980c",
  null
  
)

export default component.exports